import { jsx as _jsx } from "react/jsx-runtime";
import { ContainerTitle, ContainerSubTitle, ContainerSmallerTitle } from './style';
import { useTypedTheme } from '@monorepo-web/styles';
export default function Titulo(props) {
    return _jsx(ContainerTitle, { children: props.children });
}
export const Subtitulo = (props) => {
    return (_jsx(ContainerSubTitle, Object.assign({ smallerFontSize: true, mb: props.mb, center: props.center }, { children: props.children })));
};
export const SmallerTitle = (props) => {
    return _jsx(ContainerSmallerTitle, { children: props.children });
};
export const CartCounter = (props) => {
    const theme = useTypedTheme();
    return _jsx(ContainerSmallerTitle, Object.assign({ style: { color: theme.lineColor } }, { children: props.children }));
};
